module.exports = "<div class=\"tabs mb24\">\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.special.active\" class=\"tabs__item mr8\">\n        <span translate=\"tab_active\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.special.archived\" class=\"tabs__item mr8\">\n        <span translate=\"tab_archived\"></span>\n    </a>\n</div>\n\n<div ui-view></div>\n\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/discountForStaff/special-tab/discount-for-staff-special-tab.component.html
// module id = 740
// module chunks = 0